import { storageGet, storageSet } from './safeStorage';

const GA4_ID = 'G-C14JLNRV51';
const CONVERSION_EVENT = 'ads_conversion_request_quote';
const ADS_SEND_TO = process.env.REACT_APP_ADS_CONVERSION_SEND_TO || '';
const ADS_ID = ADS_SEND_TO.split('/')[0];

const gtag = (...args) => {
  try { if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag(...args); } catch (e) { /* tracking blocked */ }
};

let adsConfigured = false;
export const ensureAdsConfig = () => {
  if (adsConfigured || !ADS_ID) return;
  adsConfigured = true;
  gtag('config', ADS_ID);
};

export const trackLeadCreated = () => {
  try {
    if (typeof window !== 'undefined' && typeof window.oaiq === 'function') {
      window.oaiq('measure', 'lead_created', { type: 'customer_action' });
    }
  } catch (e) { /* ignore */ }
};

// Secondary GA4-only events (never the primary lead conversion). No PII.
export const trackEvent = (name, params = {}) => gtag('event', name, { send_to: GA4_ID, ...params });

const CONTACT_LINKS = [
  [/^tel:/i, 'contact_phone_click'],
  [/^mailto:/i, 'contact_email_click'],
  [/^https?:\/\/(wa\.me|api\.whatsapp\.com|wa\.link)/i, 'contact_whatsapp_click'],
];

const linkLocation = (a) => {
  const tagged = a.closest('[data-link-location]');
  if (tagged) return tagged.getAttribute('data-link-location');
  if (a.closest('header')) return 'header';
  if (a.closest('footer')) return 'footer';
  return 'content';
};

// One document-level listener: counts clicks on the link OR any icon/label inside it exactly once.
export const installContactClickTracking = () => {
  if (typeof document === 'undefined' || document.__maxqContactClicks) return;
  document.__maxqContactClicks = true;
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    const href = a.getAttribute('href') || '';
    const hit = CONTACT_LINKS.find(([re]) => re.test(href));
    if (!hit) return;
    trackEvent(hit[1], { link_location: linkLocation(a), page_path: window.location.pathname });
  }, true);
};

// Fire exactly once per saved lead, only after the backend confirmed persistence. No PII.
export const trackQuoteRequest = (formSource, leadId) => {
  if (typeof window === 'undefined' || !leadId) return;
  const key = `maxq_conv_${leadId}`;
  if (storageGet('sessionStorage', key)) return;
  storageSet('sessionStorage', key, '1');
  gtag('event', CONVERSION_EVENT, { send_to: GA4_ID, form_source: formSource });
  if (ADS_SEND_TO) {
    ensureAdsConfig();
    gtag('event', 'conversion', { send_to: ADS_SEND_TO, value: 1.0, currency: 'EUR', transaction_id: leadId });
  }
  trackLeadCreated();
};
